import React from 'react';

function LogoComponent({ src, alt = 'Logo', style = {} }) {
  if (!src) return null;
  return (
    <div className="logo-component" style={{ textAlign: 'center' }}>
      <img
        src={src}
        alt={alt}
        style={{
          display: 'block',
          margin: '0 auto',
          maxHeight: 80,
          maxWidth: '80%',
          objectFit: 'contain',
          ...style,
        }}
      />
    </div>
  );
}

export default LogoComponent;
